define(['common/parameterApplications'],
    function(parameterApplications) {

        function isQueryParameter(fieldEntry) {
            var field = fieldEntry[1];
            return !field.application || field.application === parameterApplications.QUERY;
        }

        function isPathParam(fieldEntry) {
            var field = fieldEntry[1];
            return field.application === parameterApplications.PATH;
        }

        function isPostParam(fieldEntry) {
            var field = fieldEntry[1];
            return field.application === parameterApplications.POST;
        }

        function getFieldEntryName(fieldEntry) {
            return fieldEntry[0];
        }

        function toEntry(source) {
            return function(fieldName) {
                return [fieldName, source[fieldName]];
            };
        }

        function createParamsNames(fields, paramsFilterFunction) {
            return Object.keys(fields).map(toEntry(fields)).filter(paramsFilterFunction).map(getFieldEntryName);
        }

        function createQueryParamsNames(fields) {
            return createParamsNames(fields, isQueryParameter);
        }

        function createPathParamsNames(fields) {
            return createParamsNames(fields, isPathParam);
        }

        function createPostParamsNames(fields) {
            return createParamsNames(fields, isPostParam);
        }

        function createParams(fields, createParamNamesFunction, requestOptions) {
            var params = {};
            createParamNamesFunction(fields).forEach(function(paramName) {
                if (paramName in requestOptions) {
                    params[paramName] = requestOptions[paramName];
                }
            });

            return params;
        }

        function createPathParams(fields, requestOptions) {
            return createParams(fields, createPathParamsNames, requestOptions);
        }

        return function(fields, requestOptions) {
            return {
                pathParams: createPathParams(fields, requestOptions),
                queryParams: createParams(fields, createQueryParamsNames, requestOptions),
                postParams: createParams(fields, createPostParamsNames, requestOptions)
            };
        };
    });



// WEBPACK FOOTER //
// ./rest/routing/request/requestParamsFactory.js